import React, { useEffect } from 'react';

import { applicationStore, isMobile } from '@pascal/pascal-core';

import { oddStore } from '../../store/oddStore';
import { doBetStore } from '../../store/doBetStore';
import { reBetStore } from '../../store/reBetStore';
import { loadingStore } from '../../store/loadingStore';
import { totalBetStore } from '../../store/totalBetStore';
import { liveBetsDataStore } from '../../store/liveBetsDataStore';

import { gameService } from '../../services';
import { soundService } from '../../services/soundService';
import { gameAnimations } from '../../services/GameAnimationService';
import { visibilityChangeHandler } from '../../helpers/visibilityChangeHandler';

import { WebGame } from '../webGame';
import { MobileGame } from '../mobileGame';
import SoundWatcher from '../../components/soundWatcher';

function GameWebMobileContainer() {
  useEffect(() => {
    loadingStore.startLoaderTimer();
    document.addEventListener('visibilitychange', visibilityChangeHandler);

    return () => {
      loadingStore.isPixiLoaded = false;
      loadingStore.isGameInitialLoaded = false;
      loadingStore.progress = 50;
      doBetStore.resetPigsData();
      reBetStore.setReBetInfo([]);
      totalBetStore.setTotalBet(0);
      liveBetsDataStore.setLiveBetsData([]);
      soundService.stopAll();
      applicationStore.setIsDemo(false);
      oddStore.resetOddData();

      if (gameService.handleConnectionStatusInterval) {
        clearInterval(gameService.handleConnectionStatusInterval);
      }

      if (gameService.handleConnectionStatusTimeOut) {
        clearInterval(gameService.handleConnectionStatusTimeOut);
      }

      if (gameService.delayCancellation) {
        gameService.delayCancellation.cancel();
      }
      gameAnimations.killBackgroundLoop();

      document.removeEventListener('visibilitychange', visibilityChangeHandler);
    };
  }, []);

  return (
    <>
      {isMobile() ? <MobileGame /> : <WebGame />}
      <SoundWatcher />
    </>
  );
}

export default GameWebMobileContainer;
